module.exports = __webpack_public_path__ + "img/Menu-13.2893364e.png";